import { Component, Directive, HostBinding, Input, model } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { InputText } from 'primeng/inputtext'

@Directive({
   selector: '[vcInput]',
   hostDirectives: [InputText],
   standalone: true,
})
export class VCInputDirective {
   @HostBinding('class.form-control') classFormControl = true
   @HostBinding('attr.autocomplete') autocomplete = 'off'
}
